import { Course, Settings } from '../types/course';

export const initialCourses: Course[] = [
  {
    id: '1',
    titre: 'Modélisation 3D Basique',
    description: 'Apprenez les bases de la modélisation 3D avec Blender. Parfait pour débuter dans la création 3D.',
    image: 'https://images.unsplash.com/photo-1610563166150-b34df4f3bcd6?auto=format&fit=crop&q=80&w=1200',
    categories: ['Modélisation', 'Blender'],
    duree: '12 heures',
    niveau: 'Débutant',
    prix: 99.99,
    prixPromo: 79.99,
    lien: '/cours/modelisation-basique',
    tags: ['Blender', '3D', 'Débutant'],
    rating: 4.5
  },
  {
    id: '2',
    titre: 'Animation Avancée',
    description: 'Maîtrisez les techniques avancées d\'animation 3D pour donner vie à vos créations.',
    image: 'https://images.unsplash.com/photo-1617396900799-f4ec2b43c7ae?auto=format&fit=crop&q=80&w=1200',
    categories: ['Animation', 'Blender'],
    duree: '15 heures',
    niveau: 'Avancé',
    prix: 149.99,
    lien: '/cours/animation-avancee',
    tags: ['Animation', '3D', 'Professionnel'],
    rating: 5
  }
];

export const initialSettings: Settings = {
  logo: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&q=80&w=100',
  categories: ['Modélisation', 'Animation', 'Texturing', 'Rendu'],
  pageTitle: 'Les Créateurs 3D - Formations',
  tags: ['Blender', '3D', 'Animation', 'Débutant', 'Professionnel', 'Texturing', 'Rendu']
};